const multiCasesProperty = 'assigned_in_some_cases';

export const checkIsMultiCases = (item) => Object.hasOwnProperty.call(item, multiCasesProperty);